import { FormControl, FormGroup, Validators } from '@angular/forms';
import { State } from 'src/app/interfaces/state';

// Most validators (except for VendorId) are required by VIVE Admin input. Not when Vendor uploads license.
export class LicenseForm extends FormGroup<{
  id: FormControl<number | undefined>;
  VendorId: FormControl<number | undefined>;
  verificationType: FormControl<
    'Online Verified' | 'Image Verified' | 'Non-License / Certificate' | null
  >;
  licensorRegion: FormControl<'State' | 'Municipality' | 'Both' | null>;
  issueDate: FormControl<Date | null>;
  expirationDate: FormControl<Date | null>;
  licenseNumber: FormControl<string | null>;
  licenseState: FormControl<string | undefined>;
  licenseFileName: FormControl<string | undefined>;
  licenseFile: FormControl<string | undefined>;
  LicenseFileId: FormControl<number | undefined>;
  status: FormControl<'Active' | 'Revoked' | 'Lapsed' | 'Archived' | null>;
  classification: FormControl<string | null>;
  municipalityName: FormControl<string | null>;
  name: FormControl<string | undefined>;
  PrimaryTradeId: FormControl<number | null>;
  state: FormControl<State | null>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      VendorId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      verificationType: new FormControl<
        | 'Online Verified'
        | 'Image Verified'
        | 'Non-License / Certificate'
        | null
      >(null),
      licensorRegion: new FormControl<'State' | 'Municipality' | 'Both' | null>(
        null,
        { validators: [Validators.required] }
      ),
      issueDate: new FormControl<Date | null>(null),
      expirationDate: new FormControl<Date | null>(null, {
        validators: [Validators.required]
      }),
      licenseNumber: new FormControl<string | null>(null),
      licenseState: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      licenseFileName: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      licenseFile: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      LicenseFileId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      status: new FormControl<
        'Active' | 'Revoked' | 'Lapsed' | 'Archived' | null
      >(null, { validators: [Validators.required] }),
      classification: new FormControl<string | null>(null),
      municipalityName: new FormControl<string | null>(null),
      name: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      PrimaryTradeId: new FormControl<number | null>(null),
      state: new FormControl<State | null>(null)
    });
  }

  public applyLicenseFileValidationForExistingFile(
    hasExistingFile: boolean
  ): void {
    const licenseFileControl = this.controls.licenseFile;

    if (hasExistingFile) {
      licenseFileControl.clearValidators();
    } else {
      licenseFileControl.setValidators([Validators.required]);
    }

    licenseFileControl.updateValueAndValidity();
  }
}
